import D2C_Entity from './Entity'
import utils from '@/utils'

class D2C_Stack extends D2C_Entity {
  target = 'stack'
  static active = true
  static objectType = 'stack'
  static fields = {
    project: {
      default: null,
      label: 'Project',
      placeholder: 'Select project...',
      required: true,
      width: 5,
      validate(value) {
        if (!value) {
          return 'Project is not selected'
        }
        return null
      },
      importing: {},
    },
    hosts: {
      default: [],
      validate(value, entity) {
        if (!value.length) {
          return ['No hosts']
        }
        let hasBusyPorts = false
        const busyHosts = value.map(host => {
          if (entity.services.length && host.id) {
            const hostServices = entity.services.filter(service => service.hosts && service.hosts.find(h => h.id === host.id))
            const busyPorts = host._remotePorts.filter(port => {
              return hostServices.find(service => {
                return service.remoteAccess && service.ports.find(p => p.protocol + p.value === port.protocol + port.value)
              })
            })
            if (busyPorts.length) {
              hasBusyPorts = true
              return busyPorts
            }
            return null
          }
          return null
        })
        if (hasBusyPorts) {
          return busyHosts.map(ports => {
            return ports ? `busy ports: ` + ports.map(port => port.protocol + ':' + port.value).join(', ') : null
          })
        }
        return value.map(host => {
          return host.validate ? host.validate('importing') : null
        })
      },
      importing: {},
    },
    services: {
      default: [],
      validate(value) {
        if (!value.length) {
          return ['No services']
        }
        return value.map(service => {
          return service.validate ? service.validate('importing') : null
        })
      },
      importing: {},
    },
    url: {
      default: '',
      examples: ['https://github.com/d2cio/wordpress-scalable-light-stack'],
      label: 'URL',
      placeholder: 'Paste archive or repository URL',
      required: false,
      width: 13,
      validate(value) {
        return !value || (utils.isRepoUrl(value) || utils.isArchiveUrl(value) || utils.isGitUrl(value)) ? null : 'Invalid URL'
      },
      importing: {},
    },
  }
  static create(props) {
    return new D2C_Stack(props)
  }
  async upsert() {
    const webServices = this.services.filter(service => service.services)
    for (let i = 0; i < this.services.length; i++) {
      await this.services[i].create('importing').then(createdService => {
        webServices.forEach(webService => {
          const servedService = webService.services.find(service => service.name === createdService.name)
          if (servedService) {
            const newConfig = webService.getServiceConfig(servedService)
            servedService.id = createdService.id
            servedService.domains = servedService.domains.length ? servedService.domains : newConfig.domains
            servedService.config = servedService.config || newConfig.config
          }
        })
      })
    }
  }
}
export default D2C_Stack
